import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { Session } from '../interfaces';
import { SaleLocation } from '../models';
import { environment } from '../../../environments/environment';
import { EntityType } from '../../picking/picking-shared';

@Injectable({ providedIn: 'root' })
export class ActionDispatchService {
  constructor(
    public apiService: ApiService // public snackbarService: SnackbarService,
  ) { }

  getActionTypes(): Observable<any[]> {
    const session: Session = JSON.parse(
      localStorage.getItem(environment.sessionAuth)
    );
    if (session && session.actionsDispatch) {
      return of(session.actionsDispatch);
    } else {
    return this.apiService
      .get(`${this.apiService.businessDispatchRead}/actions`)
      .pipe(map(data => {
        session.actionsDispatch = data;
        localStorage.setItem(environment.sessionAuth, JSON.stringify(session));
        return data;
      }));
    }
  }

  getSaleLocations(): Observable<SaleLocation[]> {
    return this.apiService
      .get(`${this.apiService.businessDispatchRead}/entities`)
      .pipe(map(data => data));
  }

  getEntities():Observable<EntityType[]>{
    return this.apiService
    .get(`${this.apiService.dispatch}/entityType`)
    .pipe(map(data => data));
  }
}
